import React from 'react';

import { Icon } from '@chakra-ui/react';

export const FileIcon = props => (
  <Icon
    viewBox="0 0 24 24"
    w="full"
    h="full"
    color="inherit"
    stroke={props?.stroke ?? 'currentColor'}
    strokeWidth={props?.strokeWidth ?? 1}
    {...props}
  >
    <path d="M19,5h-6.1396484l-0.3163452-0.9492188C12.1364746,2.8253784,10.989624,1.9989014,9.6982422,2H5C3.3438721,2.0018311,2.0018311,3.3438721,2,5v13c0.0018311,1.6561279,1.3438721,2.9981689,3,3h14c1.6561279-0.0018311,2.9981689-1.3438721,3-3V8C21.9981689,6.3438721,20.6561279,5.0018311,19,5z M21,18c-0.0014038,1.1040039-0.8959961,1.9985962-2,2H5c-1.1040039-0.0014038-1.9985962-0.8959961-2-2V5c0.0014038-1.1040039,0.8959961-1.9985962,2-2h4.6982422c0.8607788-0.0007324,1.6251831,0.550293,1.8964844,1.3671875l0.4306641,1.2910156C12.09375,5.8622437,12.28479,5.9998169,12.5,6H19c1.1040039,0.0014038,1.9985962,0.8959961,2,2V18z" />
  </Icon>
);
